import { render, staticRenderFns } from "./Sixth.vue?vue&type=template&id=a35b0a86&scoped=true"
import script from "./Sixth.vue?vue&type=script&lang=js"
export * from "./Sixth.vue?vue&type=script&lang=js"
import style0 from "./Sixth.vue?vue&type=style&index=0&id=a35b0a86&prod&scoped=true&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35b0a86",
  null
  
)

export default component.exports